import type { GestorDashboardPayload } from '@/components/Gestores/gestorDashboardTypes'

export function operationalMatchesPeriod(
  payload: GestorDashboardPayload | null,
  createdFrom: string,
  createdTo: string,
): payload is GestorDashboardPayload {
  if (!payload) return false
  return payload.period.createdFrom === createdFrom && payload.period.createdTo === createdTo
}

export function filterEntriesWithinPeriod<T extends { date: string | null }>(
  entries: T[],
  createdFrom: string,
  createdTo: string,
): T[] {
  return entries.filter((entry) => {
    if (!entry.date) return false
    return entry.date >= createdFrom && entry.date <= createdTo
  })
}
